import { render, staticRenderFns } from "./CartTableCustomItemRow.vue?vue&type=template&id=3ff71797&"
import script from "./CartTableCustomItemRow.vue?vue&type=script&lang=js&"
export * from "./CartTableCustomItemRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports